import React, { useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import Layout from 'antd/lib/layout';
import Drawer from 'antd/lib/drawer';

import Dropdown from 'antd/lib/dropdown';
import Avatar from 'antd/lib/avatar';
import List from 'antd-mobile/lib/list';
import { logout } from '../../API';

import hamburgerIconLight from './assets/hamburger-menu-light.svg';
import hamburgerIconDark from './assets/hamburger-menu-dark.svg';
import lightModeIcon from '../../icons/darkmode-off.svg';
import darkModeIcon from '../../icons/darkmode-on.svg';

import logo from '../../images/logo.png';
import darkModeLogo from '../../images/logo-light.png';

import './Header.less';
import { BuildingDropdown } from '../UI/BuildingDropdown';

const HeaderControl = (props) => {
  const { pathname } = useLocation();
  const { Header } = Layout;
  const {
    buildings,
    theme,
    changeTheme,
    setSelectedBuildingId,
    selectedBuildingInfo,
    setSelectedBuildingInfo,
    selectBuilding,
    selectedBuildingId,
  } = props;
  const user = JSON.parse(localStorage.getItem('current_user'));
  const userName = `${user.first_name} ${user.last_name}`;
  const userDisplayName = `${user.first_name[0]}${user.last_name[0]}`;
  const history = useHistory();

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);

  const mobileMenu = (
    <List className="app-header-mobile__menu-list">
      <List.Item key="Profile" className="app-header-mobile__profile">
        <Avatar
          className="app-header-mobile__profile-icon"
          alt="profile icon"
          style={{ backgroundColor: user.avatar_color || '#ffffff' }}
        >
          {userDisplayName}
        </Avatar>
        <div className="app-header-mobile__profile-name">{userName}</div>
      </List.Item>
      <List.Item
        key="Settings"
        onClick={() => {
          history.push('/settings');
          toggleMobileMenu();
        }}
      >
        Settings
      </List.Item>
      <List.Item
        key="Help"
        onClick={() => {
          history.push('/help');
          toggleMobileMenu();
        }}
      >
        Help
      </List.Item>
      <List.Item
        key="Logout"
        onClick={async () => {
          await logout();
          history.push('/login');
        }}
      >
        Sign out
      </List.Item>
    </List>
  );

  const navigateHome = () => {
    if (pathname !== '/') {
      setSelectedBuildingId('');
      setSelectedBuildingInfo({});
      history.push('/');
    }
  };

  const userItems = [
    {
      key: 'Settings',
      label: (
        <div
          onClick={() => {
            selectBuilding({});
            history.push('/settings');
          }}
        >
          Settings
        </div>
      ),
    },
    {
      key: 'Help',
      label: (
        <div
          onClick={() => {
            history.push('/help');
          }}
        >
          Help
        </div>
      ),
    },
    {
      key: 'Logout',
      label: (
        <div
          onClick={async () => {
            await logout();

            history.push('/login');
          }}
        >
          Sign out
        </div>
      ),
    },
  ];

  return (
    <>
      <Header className={`app-header-${theme}`}>
        <div className="app-header__main-container">
          <div className="app-header__logo-container">
            <img
              role="button"
              tabIndex="0"
              className="app-header__parity-logo"
              src={theme === 'light' ? logo : darkModeLogo}
              alt="Parity Logo"
              onClick={navigateHome}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') navigateHome();
              }}
            />
          </div>
          <div className="app-header__buttons">
            
            <div role="presentation" onClick={changeTheme} className="hb-dynamic-control">
              {theme === 'light' ? (
                <img className="app-header__dark-mode" src={lightModeIcon} alt="Light Mode" />
              ) : (
                <img className="app-header__dark-mode" src={darkModeIcon} alt="Dark Mode" />
              )}
            </div>
            {history.location.pathname === '/' || history.location.pathname === '/settings' ? null : (
              <span className="hb-dynamic-control">
                <BuildingDropdown
                  items={buildings}
                  callback={(c) => {
                    const { identifier } = c;
                    selectBuilding(buildings.find((b) => b.identifier === identifier));
                    history.push(`/monitoring/${identifier}/`);
                  }}
                  theme={theme}
                  filter={selectedBuildingInfo.name}
                  renderCondition={selectedBuildingId && history.location.pathname !== '/'}
                />
              </span>
            )}
                
            <Dropdown
              className={`app-dropdown app-dropdown-${theme}`}
              trigger={['click']}
              style={{ width: '200px', marginLeft: '20px' }}
              menu={{ items: userItems }}
            >
              <div className="app-header__profile">
                <Avatar
                  className="app-profile-icon"
                  alt="profile icon"
                  style={{ backgroundColor: user.avatar_color || '#ffffff' }}
                >
                  {userDisplayName}
                </Avatar>
                <div className="app-header__profile-name">{userName}</div>
              </div>
            </Dropdown>
          </div>
          <div
            className="app-header__hamburger-menu"
            onClick={toggleMobileMenu}
            onKeyDown={toggleMobileMenu}
            role="button"
            tabIndex={0}
          >
            <img
              src={theme === 'light' ? hamburgerIconLight : hamburgerIconDark}
              alt="mobile-menu"
              className="app-header__hamburger-menu-mobile"
            />
          </div>
        </div>
        
      </Header>
      <Drawer
        className={`app-header-mobile__drawer-${theme}`}
        placement="top"
        contentWrapperStyle={{ height: 'auto' }}
        open={mobileMenuOpen}
        onClose={toggleMobileMenu}
      >
        {mobileMenu}
      </Drawer>
    </>
  );
};

export default HeaderControl;
